import { Panel } from "primereact/panel";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { createContext, useEffect, useRef, useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { GenericComponent } from "../../components/GenericComponent";
import { RiesgoPerfilCalendario } from "./RiesgoPerfilCalendario";
import { ListaRiesgo } from "./ListaRiesgo";
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import multiMonthPlugin from '@fullcalendar/multimonth';
import { ParametroEmpresa } from "./ParametroEmpresa";
import { useToken } from '../../components/useToken';
import { ProgressSpinner } from "primereact/progressspinner";

export const RiesgoPerfilContext = createContext(null);

export const RiesgoPerfil = () => {
    const { getRol } = useToken();
    const [activeIndex, setActiveIndex] = useState(0);
    const [permss, setPermss] = useState(null);
    const [funcionalidades, setFuncionalidades] = useState([]);
    const [nivelesRiesgo, setNivelesRiesgo] = useState([]);
    const [nivelesAlerta, setNivelesAlerta] = useState([]);
    const [procedimientosControl, setProcedimientosControl] = useState([]);
    const [justificaciones, setJustificaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const monitoreoService = new MonitoreoService();
    const toast = useRef(null);
    const generic = new GenericComponent();

    useEffect(() => {
        inicio();
    }, []);

    useEffect(() => {
        if (funcionalidades.length > 0) {
            const tabsOrdenadas = [ // Deben tener el mismo orden declarado en el acordeón
                { key: "monitoreo-perfil-vista-lista" },
                { key: "monitoreo-perfil-vista-mes" },
                { key: "monitoreo-perfil-vista-year" },
                { key: "monitoreo-perfil-tab-configuracion" }
            ];

            const primerIndexVisible = tabsOrdenadas.findIndex(tab =>
                funcionalidades.includes(tab.key)
            );

            if (primerIndexVisible !== -1) {
                setActiveIndex(primerIndexVisible);
            }
        }
    }, [funcionalidades]);

    const inicio = () => {
        const rolId = getRol()?.id ?? '';
        monitoreoService.consultar(0, 'monitoreo/nivel-riesgo-perfil/permission', { rol: rolId }).then(res => {
            setPermss(res.data.perss);
            setFuncionalidades(res.data.funcionalidades);
            setNivelesRiesgo(res.data.niveles_de_riesgo);
            setNivelesAlerta(res.data.niveles_de_alerta);
            setProcedimientosControl(res.data.procedimientos_control);
            setJustificaciones(res.data.justificaciones);
        }).finally(() => {
            setLoading(false)
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const contextoData = { nivelesRiesgo, nivelesAlerta, procedimientosControl, justificaciones };

    return (
        <>
            <Toast ref={toast} />
            <div style={{ position: 'relative', minHeight: '500px' }}>
                {loading && (
                    <div style={{ position: 'absolute', zIndex: 10, top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem', fontSize: '1.2rem', color: '#444', fontWeight: 500 }} >
                        <ProgressSpinner style={{ width: '57.5px', height: '57.5px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
                        <span>Un momento por favor, estamos cargando la información...</span>
                    </div>
                )}
                <div style={{ opacity: loading ? 0.3 : 1, pointerEvents: loading ? 'none' : 'auto', transition: 'opacity 0.3s ease' }}></div>
                {!loading && (
                    <RiesgoPerfilContext.Provider value={contextoData}>
                        <Panel>
                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                {siOpcion("monitoreo-perfil-vista-lista") && (
                                    <TabPanel header="Vista en lista">
                                        <ListaRiesgo permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-perfil-vista-mes") && (
                                    <TabPanel header="Vista mensual">
                                        <RiesgoPerfilCalendario permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} justificaciones={justificaciones} procedimientosControl={procedimientosControl} nivelesRiesgo={nivelesRiesgo} nivelesAlerta={nivelesAlerta} plugins={[interactionPlugin, dayGridPlugin]} initialView="dayGridMonth" />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-perfil-vista-year") && (
                                    <TabPanel header="Vista anual">
                                        <RiesgoPerfilCalendario permss={permss} funcionalidades={funcionalidades} toast={toast} generic={generic} justificaciones={justificaciones} procedimientosControl={procedimientosControl} nivelesRiesgo={nivelesRiesgo} nivelesAlerta={nivelesAlerta} plugins={[interactionPlugin, multiMonthPlugin]} initialView="multiMonthYear" />
                                    </TabPanel>
                                )}
                                {siOpcion("monitoreo-perfil-tab-configuracion") && (
                                    <TabPanel header="Configuración">
                                        <ParametroEmpresa toast={toast} generic={generic} permss={permss} funcionalidades={funcionalidades} />
                                    </TabPanel>
                                )}
                            </TabView>
                        </Panel>
                    </RiesgoPerfilContext.Provider>
                )}
            </div>
        </>
    )
}
